import { useEffect, useState } from 'react';
import { api } from '../api';
import { ChipToggle, Empty, ErrorBox, Icon, Loading, PageHead, Panel } from '../components/ui';
import { dueLabel, pct } from '../format';
import { useApi } from '../hooks';

const recallTone = (r: number | null) => (r == null ? '' : r >= 0.85 ? 'good' : r >= 0.7 ? 'warn' : 'bad');

export function KnowledgeList({ initialDomain = '' }: { initialDomain?: string }) {
  const [text, setText] = useState('');
  const [q, setQ] = useState('');
  const [domain, setDomain] = useState(initialDomain);
  const [sort, setSort] = useState('recent');
  const [archived, setArchived] = useState(false);
  useEffect(() => {
    const t = window.setTimeout(() => setQ(text), 250);
    return () => window.clearTimeout(t);
  }, [text]);
  const items = useApi(() => api.items({ q, domain, sort, archived }), [q, domain, sort, archived]);
  const domains = useApi(api.domains);

  return (
    <>
      <PageHead
        title="개인 지식 DB"
        sub="개념 하나 = 정의·원리·사례·활용·반례 → 복습 카드가 자동으로 생깁니다"
        actions={<><a className="btn btn-ghost" href="#/guide/memory">오래 기억하는 법</a><a className="btn btn-primary" href="#/knowledge/new"><Icon name="plus" size={16} />새 개념</a></>}
      />
      <div className="toolbar">
        <input className="input" type="search" placeholder="개념·정의·태그 검색" aria-label="검색" value={text} onChange={(e) => setText(e.target.value)} />
        <select className="input" aria-label="정렬" value={sort} onChange={(e) => setSort(e.target.value)}>
          <option value="recent">최근 수정 순</option>
          <option value="weak">기억 약한 순</option>
          <option value="title">가나다 순</option>
        </select>
        <label className="check">
          <input type="checkbox" checked={archived} onChange={(e) => setArchived(e.target.checked)} /> 보관함
        </label>
      </div>
      {domains.data && domains.data.length > 0 && (
        <div className="chips">
          <ChipToggle on={domain === ''} onClick={() => setDomain('')}>전체</ChipToggle>
          {domains.data.map((d) => (
            <ChipToggle key={d.domain} on={domain === d.domain} onClick={() => setDomain(d.domain === domain ? '' : d.domain)}>
              {d.domain} <span className="muted">{d.count}</span>
            </ChipToggle>
          ))}
        </div>
      )}
      {items.error ? (
        <ErrorBox message={items.error} onRetry={items.reload} />
      ) : !items.data ? (
        <Loading />
      ) : items.data.length === 0 ? (
        <Panel>
          <Empty>{q || domain || archived ? '조건에 맞는 개념이 없습니다.' : '아직 개념이 없습니다. 오늘 배운 것 하나를 자기 말로 정리해 보세요.'}</Empty>
        </Panel>
      ) : (
        <ul className="item-list">
          {items.data.map((it) => (
            <li key={it.id}>
              <a className="panel item-row" href={`#/knowledge/${it.id}`}>
                <div className="grow">
                  <div className="item-title">
                    <b>{it.title}</b>
                    {it.domain && <span className="badge">{it.domain}</span>}
                  </div>
                  {it.definition && <p className="muted small clamp-2">{it.definition}</p>}
                </div>
                <div className="item-side">
                  <span className={`recall ${recallTone(it.recall)}`} title="지금 떠올릴 확률 (FSRS 예측 평균)">{it.recall != null ? pct(it.recall) : '—'}</span>
                  <span className="muted small">
                    {it.due_count > 0 ? `복습 ${it.due_count}장` : it.next_due ? dueLabel(it.next_due) : `카드 ${it.card_count}장`}
                  </span>
                </div>
              </a>
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
